import {
  GlucoseSpecialValue,
  GlucoseUnit,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useGetGlucoseValue } from "./useGetGlucoseValue"
import { usePolyglot } from "src/contexts"
import { useGlucoseUnit } from "src/hooks/account"
import { round } from "src/utils"

/*
 * returns a function that returns the glucose value
 * in a readable scaled and rounded string
 */
export function useDisplayGlucoseValue(): (value: number, specialValue?: GlucoseSpecialValue) => string {
  const polyglot = usePolyglot()
  const glucoseUnit = useGlucoseUnit()
  const getGlucoseValue = useGetGlucoseValue()
  const polyglotPrefix = "pages.home.current_reading."

  return useCallback(
    (value: number, specialValue?: GlucoseSpecialValue) => {

      if (specialValue === GlucoseSpecialValue.High) {
        return polyglot.t(`${polyglotPrefix}high`)
      }
      if (specialValue === GlucoseSpecialValue.Low) {
        return polyglot.t(`${polyglotPrefix}low`)
      }

      const scaledValue = getGlucoseValue(value)
      if (glucoseUnit === GlucoseUnit.MillimolesPerLiter) {
        const roundedValue = round(
          scaledValue,
          1,
        )

        return roundedValue.toLocaleString(
          polyglot.locale(),
          { minimumFractionDigits: 1 },
        )
      }

      return round(scaledValue).toLocaleString(polyglot.locale())
    },
    [
      getGlucoseValue,
      glucoseUnit,
      polyglot,
    ],
  )
}
